<template>
  <v-card flat class="futuristic-card col-lg-12 col-lg-offset-1">
    <div class="hpanel">
      <div class="col-lg-12">
        <div class="hpanel">
          <div class="panel-body">
            <div class="card-header">
              <h4 class="earth-color">PAYMENT SEARCH</h4>
              <div class="title-decoration"></div>
            </div>
            
            <div class="m-t-sm">
              <v-form @submit.prevent="searchTerm()">
                <h6 class="earth-color">KEYWORD SEARCH</h6>
                <v-layout row wrap>
                  <v-flex lg8 md8 sm8 xs8 v-if="tab_item == 'iveri_failed'">
                    <v-container>
                      <v-text-field
                        label="Search by: Booking Ref , Card Number"
                        v-model="term.key"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex
                    lg8
                    md8
                    sm8
                    xs8
                    v-else-if="tab_item == 'booking_payments'"
                  >
                    <v-container>
                      <v-text-field
                        label="Search by: Booking Ref, Transaction Reference"
                        v-model="term.key"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg8 md8 sm8 xs8 v-else-if="tab_item == 'bank_slip'">
                    <v-container>
                      <v-text-field
                        label="Search by: Booking Ref , Name , Bank Slip Reference , Amount ,Payment Receipt"
                        v-model="term.key"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm4 xs4>
                    <v-container fluid class="action-buttons">
                      <v-btn depressed color="#587e27" class="futuristic-btn action-btn" type="submit">
                        <i class="fa fa-search"></i> Search
                      </v-btn>
                      <v-btn depressed color="#ef5350" class="futuristic-btn action-btn" @click="reset()" :loading="$loadingTrue"
                        >Reset</v-btn
                      >
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
            
            <hr class="divider" />
            
            <div class="m-t-sm">
              <v-form @submit.prevent="searchRange()">
                <h6 class="earth-color">SEARCH BY CREATION DATE</h6>

                <v-layout row wrap>
                  <v-flex lg3 md3 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="range.start_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Start Date"
                          v-model="range.start_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker v-model="range.start_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            flat
                            color="#ef5350"
                            class="futuristic-btn"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            class="futuristic-btn"
                            @click="$refs.dialog.save(range.start_date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="range.end_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="End Date"
                          v-model="range.end_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker v-model="range.end_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            flat
                            color="#ef5350"
                            class="futuristic-btn"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            class="futuristic-btn"
                            @click="$refs.dialog1.save(range.end_date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex
                    lg3
                    md3
                    sm12
                    xs12
                    v-if="tab_item == 'booking_payments'"
                  >
                    <v-container fluid>
                      <v-autocomplete
                        label="Mode of Payment"
                        :items="bookingPaymentMethods"
                        :rules="[(v) => !!v || 'Mode of payment is required']"
                        required
                        item-text="payment_method_name"
                        item-value="payment_method_public_id"
                        v-model="range.payment_method"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12 v-else-if="tab_item == 'bank_slip'">
                    <v-container fluid>
                      <v-autocomplete
                        label="Select Allocation"
                        :items="allAllocations"
                        :rules="[(v) => !!v || 'Mode of payment is required']"
                        required
                        item-text="value"
                        item-value="id"
                        v-model="range.allocation"
                        class="futuristic-input"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>

                  <v-flex lg3 md3 sm4 xs4>
                    <v-container fluid class="action-buttons">
                      <v-btn depressed color="#587e27" class="futuristic-btn action-btn" type="submit">
                        <i class="fa fa-search"></i> Search
                      </v-btn>
                      <v-btn depressed color="#ef5350" class="futuristic-btn action-btn" @click="reset()" :loading="$loadingTrue"
                        >Reset</v-btn
                      >
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    {{ searchTabItem }}
  </v-card>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker";
export default {
  name: "SearchTabs",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      lmenu: JSON.parse(localStorage.getItem("unem")),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      term: {
        key: "",
      },
      range: {
        start_date: "",
        end_date: "",
        payment_method: "",
        allocation: "",
      },
      route: this.$route.name,

      tab_item: "",
    };
  },
  components: {
    HotelDatePicker,
  },
  methods: {
    searchTerm: function () {
      let searchTab = this.$store.state.BookingStore.current_payment_search;
      let searchItem = searchTab.tab_item;
      if (searchItem === "bank_slip") {
        this.$store.dispatch("search_booking_bankslip_by_key", this.term);

      } else if (searchItem === "iveri_failed") {
        this.$store.dispatch("booking_payments", this.term);
       
      } else if (searchItem === "booking_payments") {
        this.$store.dispatch("search_booking_payments_by_key", this.term);
      } else {
        let data = {
          key: this.term.key,
          partner_id: this.lmenu.instiution_id,
        };
        this.$store.dispatch("search_partner_booking_by_key", data);
      }
    },
    searchRange: function () {
      let searchTab = this.$store.state.BookingStore.current_payment_search;
      let searchItem = searchTab.tab_item;
      if (searchItem === "bank_slip") {

        this.$store.dispatch("search_bankSlip_by_date_range", this.range);

      } else if (searchItem === "iveri_failed") {
        this.$store.dispatch(
          "search_iveri_date_range",
          this.range
        );
      }else if (searchItem === "booking_payments") {

        this.$store.dispatch("search_booking_payments_by_date_range", this.range);
      } 
    },
    reset() {
      let searchTab = this.$store.state.BookingStore.current_payment_search;
      let searchItem = searchTab.tab_item;
      if (searchItem === "bank_slip") {
        this.$store.dispatch("get_all_bank_slip_data");
      } else if (searchItem === "iveri_failed") {
        this.$store.dispatch("get_bookings_payment_failure");
      } else if (searchItem === "booking_payments") {
        this.$store.dispatch("get_bookings_payments");
      }
      this.range.start_date = "";
      this.range.end_date = "";
      this.range.allocation = "";
      this.range.payment_method = "";
    },
  },
  computed: {
    allAllocations: function () {
      let bookingTypes = [
        
        {
          id: "1",
          value: "Pending Allocation",
        },
        {
          id: "2",
          value: "Allocated",
        },
      ];
      return bookingTypes;
    },
    searchTabItem: function () {
      let data = this.$store.state.BookingStore.current_payment_search;
      this.tab_item = data.tab_item;
      // return data.tab_item
    },
  },
};
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  color: white;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.divider {
  border: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
  margin: 20px 0;
}

.panel-body {
  padding: 20px;
}

.hpanel {
  margin-bottom: 25px;
  background-color: #fff;
  border: 1px solid #e4e5e7;
  border-radius: 2px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .action-buttons {
    flex-direction: row;
    justify-content: space-between;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1rem;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}
</style>